import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=45e9396e&scoped=true&"
import script from "./PhotoPreview.vue?vue&type=script&lang=js&"
export * from "./PhotoPreview.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPreview.vue?vue&type=style&index=0&id=45e9396e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9396e",
  null
  
)

export default component.exports